export * from '@primeuix/themes/aura/multiselect';
export { default } from '@primeuix/themes/aura/multiselect';
